import { toast } from "react-toastify";
import baseAPI from "../api/baseApi";
import { authHeader } from "../helpers/authHeader";

const offerRedeemCodeCheck = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("offer_code", data.offer_code);

    const res = await baseAPI.post(`/check-qr-code`, formdata, {
      headers: authHeader(),
    });
    return res;
  } catch (error) {
    toast.error(error?.response?.data?.message);
    console.log(error);
  }
};

const useOfferRedeem = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("offer_code", data.offer_code);
    formdata.append("actual_amount", data.actual_amount);
    formdata.append("discount_amount", data.discount_amount);
    formdata.append("total_amount", data.total_amount);
    formdata.append("is_point_applied", data.is_point_applied == true ? 1 : 0);
    formdata.append("point", data.point);
    formdata.append("point_amount", data.point_amount);
    formdata.append("payable_amount", data.payable_amount);
    formdata.append("is_second_transaction_discount_apply", data.is_second_transaction_discount_apply);
    if (data?.second_transaction_offer_id !== undefined) {
      formdata.append("second_transaction_offer_id", data.second_transaction_offer_id);
    }
    if (data?.second_transaction_discount !== undefined) {
      formdata.append("second_transaction_discount", data.second_transaction_discount);
    }
    if (data?.second_transaction_expire_date !== undefined) {
      formdata.append("second_transaction_expire_date", data.second_transaction_expire_date);
    }
    if (data?.old_offer_id !== undefined) {
      formdata.append("old_offer_id", data.old_offer_id);
    }

    const res = await baseAPI.post(`/use-offer`, formdata, {
      headers: authHeader(),
    });
    return res;
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.message);
  }
};

const getOffersRedeemLogs = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("page", data.page);

    const res = await baseAPI.post(`/branch-redeem-log`, formdata, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const OfferRedeemService = {
  offerRedeemCodeCheck,
  useOfferRedeem,
  getOffersRedeemLogs,
};

export default OfferRedeemService;
